import { createApp, ref, watch } from 'vue'
import ZlDrawer from '../layouts/ZlDrawer.vue'

// 创建抽屉实例
const createDrawerInstance = (options = {}) => {
  // 创建容器
  const drawerContainer = document.createElement('div')
  drawerContainer.className = 'zl-drawer-container'
  document.body.appendChild(drawerContainer)

  // 创建响应式的visible状态
  const visible = ref(false)
  
  // 创建Vue应用实例
  const app = createApp({
    setup() {
      // 监听visible变化，触发onClose回调
      watch(visible, (newValue) => {
        if (!newValue && options.onClose) {
          options.onClose()
        }
      })
      
      return {
        visible,
        ...options
      }
    },
    components: {
      ZlDrawer
    },
    template: `
      <ZlDrawer
        :visible="visible"
        :title="title"
        :width="width"
        :placement="placement"
        :closable="closable"
        :maskClosable="maskClosable"
        :showFooter="showFooter"
        @update:visible="visible = $event"
        @close="visible = false"
      >
        <slot></slot>
        <template #footer>
          <slot name="footer"></slot>
        </template>
      </ZlDrawer>
    `
  })
  
  const instance = app.mount(drawerContainer)
  
  // 添加控制方法
  instance.setVisible = (value) => {
    visible.value = value
  }
  
  instance.getVisible = () => {
    return visible.value
  }
  
  // 添加销毁方法
  instance.destroy = () => {
    app.unmount()
    if (drawerContainer && drawerContainer.parentNode) {
      drawerContainer.parentNode.removeChild(drawerContainer)
    }
  }
  
  return instance
}

// 全局抽屉方法
export const drawer = {
  // 显示抽屉
  show: (options = {}) => {
    let instance = null
    
    const drawerOptions = {
      title: '',
      width: '400px',
      placement: 'right',
      visible: false, // 初始状态为不可见
      ...options,
      onClose: () => {
        if (instance) {
          // 先隐藏抽屉，等待动画完成后再销毁
          instance.setVisible(false)
          setTimeout(() => {
            instance.destroy()
          }, 400) // 等待退出动画完成
        }
      }
    }
    
    instance = createDrawerInstance(drawerOptions)
    
    // 延迟显示以触发进入动画
    setTimeout(() => {
      if (instance) {
        instance.setVisible(true)
      }
    }, 50)
    
    // 返回实例控制对象
    return {
      instance,
      close: () => {
        if (instance) {
          instance.setVisible(false)
          setTimeout(() => {
            instance.destroy()
          }, 400) // 等待退出动画完成
        }
      }
    }
  },
  
  // 从右侧显示抽屉
  right: (options = {}) => {
    return drawer.show({
      placement: 'right',
      ...options
    })
  },
  
  // 从左侧显示抽屉
  left: (options = {}) => {
    return drawer.show({
      placement: 'left',
      ...options
    })
  },
  
  // 从顶部显示抽屉
  top: (options = {}) => {
    return drawer.show({
      placement: 'top',
      width: '300px',
      ...options
    })
  },
  
  // 从底部显示抽屉
  bottom: (options = {}) => {
    return drawer.show({
      placement: 'bottom',
      width: '300px',
      ...options
    })
  }
}

// Vue插件安装方法
export const ZlDrawerPlugin = {
  install(app) {
    // 全局属性
    app.config.globalProperties.$drawer = drawer
    
    // 提供注入
    app.provide('$drawer', drawer)
  }
}

export default drawer